import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/contact", form); setDone(true); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="bg-cream">
      <div className="brand-container py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="brand-eyebrow">Get in Touch</div>
          <h1 className="brand-h1 mt-3">Say hello.</h1>
          <p className="brand-lede mt-6">For general questions, community feedback, or a quiet word with the team.</p>
          <div className="mt-10 space-y-4 text-charcoal/80">
            <div className="flex items-center gap-3"><Mail className="w-4 h-4 text-plum" /> hello@judgeauntiesays.com</div>
            <div className="flex items-center gap-3"><Phone className="w-4 h-4 text-plum" /> Bookings: booking@judgeauntiesays.com</div>
            <div className="flex items-center gap-3"><MapPin className="w-4 h-4 text-plum" /> Chesapeake, Virginia</div>
          </div>
        </div>
        <div className="lg:col-span-7">
          {done ? (
            <div className="editorial-card p-10">
              <h2 className="brand-h2">Message received.</h2>
              <p className="mt-4 text-charcoal/70">Thanks for reaching out — we'll be in touch soon.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="editorial-card p-8 space-y-5">
              <div>
                <label className="text-sm">Your name</label>
                <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="contact-name"
                  className="mt-2 w-full rounded-md border border-gold-light bg-cream px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-gold" />
              </div>
              <div>
                <label className="text-sm">Email</label>
                <input type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} data-testid="contact-email"
                  className="mt-2 w-full rounded-md border border-gold-light bg-cream px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-gold" />
              </div>
              <div>
                <label className="text-sm">Message</label>
                <textarea rows={6} required value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} data-testid="contact-message"
                  className="mt-2 w-full rounded-md border border-gold-light bg-cream px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gold" />
              </div>
              <button disabled={busy} className="btn-primary" data-testid="contact-submit">{busy ? "Sending…" : "Send message"}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
